import { namespaceFromSkuName } from '../routing-load/loadScopeFields.ts';

export function skuShortName(skuName: string): string {
  const slash = skuName.indexOf('/');
  return slash < 0 ? skuName : skuName.slice(slash + 1);
}

export function skuNamespaceLabel(skuName: string): string {
  return namespaceFromSkuName(skuName) ?? skuName;
}

export interface SkuNameGroup<T> {
  readonly namespace: string;
  readonly items: readonly T[];
}

export function groupByNamespace<T>(
  items: readonly T[],
  nameOf: (item: T) => string,
): readonly SkuNameGroup<T>[] {
  const buckets = new Map<string, T[]>();
  for (const item of items) {
    const namespace = skuNamespaceLabel(nameOf(item));
    const existing = buckets.get(namespace);
    if (existing === undefined) buckets.set(namespace, [item]);
    else existing.push(item);
  }
  return [...buckets.keys()]
    .sort((a, b) => a.localeCompare(b))
    .map((namespace) => ({
      namespace,
      items: [...(buckets.get(namespace) ?? [])].sort((a, b) =>
        skuShortName(nameOf(a)).localeCompare(skuShortName(nameOf(b))),
      ),
    }));
}

export function truncateId(value: string, head = 16): string {
  if (value.length <= head) return value;
  return `${value.slice(0, head)}…`;
}
